import {inject, Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorsStateService} from '../../ui-state/errors-state/errors-state.service';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorService {
  /**
   * Errors State service injection
   * @private
   */
  private readonly errorsStateService: ErrorsStateService = inject(ErrorsStateService);
  /**
   * Helper method that formats an HTTP Error Response to s
   * @param err
   */
  formatError(err: HttpErrorResponse): string {
    const errMssg = this.httpErrorFormatter(err);
    this.errorsStateService.showError(errMssg);
    return errMssg;
  }

  /**
   * Helper method that formats an HTTP Error Response to a clear string message.
   * @param err
   * @private
   */
  private httpErrorFormatter(err: HttpErrorResponse): string {
    console.error(err);
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else if (typeof err.error === 'string') {
      errorMessage = err.error;
    } else {
      // The backend returned an unsuccessful response code.
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.statusText}`;
    }
    return errorMessage;
  }

}
